import { useSelector } from 'react-redux';
import camelCase from 'lodash/camelCase';

import { appliedFiltersSelector } from '@courseResume/selectors/coursePauseRequestFilter';
import { COURSE_PAUSE_REQUEST_TYPE } from '@courseResume/data/coursePauseRequestType';
import {
  currentPageSelector,
  sortRequestFieldSelector,
  sortRequestTypeSelector,
} from '@courseResume/selectors/coursePauseRequest';
import { useGetCoursePauseRequestsQuery } from '@courseResume/services/coursePauseRequestService';
import parseCoursePauseRequest from '@courseResume/utils/parseCoursePauseRequest';

export default function useFilteredCoursePauseRequests({
  requestType,
  coursePauseStatus,
}) {
  const appliedFilters = useSelector(appliedFiltersSelector);
  const sortRequestField = useSelector(sortRequestFieldSelector);
  const sortRequestType = useSelector(sortRequestTypeSelector);
  const coursePauseType = COURSE_PAUSE_REQUEST_TYPE[camelCase(requestType)];
  const currentPage = useSelector(currentPageSelector);

  const coursePauseRequestParams = parseCoursePauseRequest({
    currentPage,
    filters: appliedFilters,
    sortOrder: { field: sortRequestField, type: sortRequestType },
    coursePauseStatus,
    coursePauseType,
  });

  const response = useGetCoursePauseRequestsQuery(coursePauseRequestParams);

  return response;
}
